import { render, staticRenderFns } from "./TableAdvanced.vue?vue&type=template&id=ca8bde3a"
import script from "./TableAdvanced.vue?vue&type=script&lang=js"
export * from "./TableAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports